import { Button, CircularProgress } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import ProgressBar from "react-customizable-progressbar";

export default function HealthScore({
  onBoardingUser = {},
  step = 0,
  setStep = () => {},
  score = 0,
  setScore = () => {},
  scorePercentage = 0,
  setScorePercentage = () => {},
  tag = "",
  setTag = () => {},
  verifying = false,
  getHealthScoreHandler = () => {},
}) {
  useEffect(() => {
    getHealthScoreHandler();
  }, []);

  // const ismobile = window.innerWidth <= 768;

  return (
    <>
      <div
        className="onboarding-step onboarding-step-7"
        style={{ padding: "1rem" }}
      >
        <div
          className="score-card"
          style={
            {
              // padding: ismobile ? 0 : 30,
            }
          }
        >
          {verifying ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ProgressBar
                radius={120}
                progress={scorePercentage}
                strokeWidth={15}
                strokeColor={
                  tag === "worst"
                    ? "#FF0000"
                    : tag === "bad"
                    ? "#FF9635"
                    : tag === "good"
                    ? "#8FBF07"
                    : tag === "great"
                    ? "#00BE2A"
                    : "#EEEEEE"
                }
                trackStrokeWidth={15}
                pointerRadius={10}
                pointerStrokeWidth={10}
                pointerStrokeColor={
                  tag === "worst"
                    ? "#FF0000"
                    : tag === "bad"
                    ? "#FF9635"
                    : tag === "good"
                    ? "#8FBF07"
                    : tag === "great"
                    ? "#00BE2A"
                    : "#EEEEEE"
                }
                cut={80}
                rotate={-230}
              >
                <div className="indicator">
                  <div>
                    <p
                      className="score"
                      style={{
                        color:
                          tag === "worst"
                            ? "#FF0000"
                            : tag === "bad"
                            ? "#FF9635"
                            : tag === "good"
                            ? "#8FBF07"
                            : tag === "great"
                            ? "#00BE2A"
                            : "#EEEEEE",
                      }}
                    >
                      {score}
                    </p>
                    <p
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#D7D7D7",
                      }}
                    >
                      Your health score
                    </p>
                    <div className={`tag tag-${tag}`}>{tag}</div>
                  </div>
                </div>
              </ProgressBar>
            </div>
          )}
          {!verifying && tag !== "" && (
            <p
              className="score-para"
              style={{
                color: "#FFFFFF",
                fontSize: 24,
              }}
            >
              {/* {onBoardingUser?.first_name}, you’re doing {tag}, <br/>all the best */}
              {(() => {
                switch (tag) {
                  case "worst":
                    return (
                      <>
                        Hey, {onBoardingUser?.first_name}, You need to get
                        moving on your health!
                      </>
                    );
                  case "bad":
                    return (
                      <>
                        Hey, {onBoardingUser?.first_name}, Your health is in a
                        really bad shape, we recommend you to connect with an
                        expert immediately!
                      </>
                    );
                  case "neutral":
                    return (
                      <>
                        Hey, {onBoardingUser?.first_name}, You need some
                        improvement on your health, lets start with daily
                        exercise & healthy food?
                      </>
                    );
                  case "good":
                    return (
                      <>
                        Hey, {onBoardingUser?.first_name}, You're doing good!
                        Let's keep pushing for a better you!
                      </>
                    );
                  case "great":
                    return (
                      <>
                        Hey, {onBoardingUser?.first_name}, Seems like you're in
                        the best shape of your life! Why don't you be an expert
                        and guide others?
                      </>
                    );
                  default:
                    return null;
                }
              })()}
            </p>
          )}
        </div>
      </div>
      <div
        className="request-footer-btn"
        style={{ background: "transparent", border: "none", boxShadow: "none" }}
      >
        <Button
          onClick={() => setStep(step + 1)}
          fullWidth
          variant="contained"
          size="large"
          style={{
            padding: "16px 0",
            fontSize: "1em",
            background:
              "linear-gradient(91.75deg, #FFFFFF 0.11%, #C4C4C4 100.1%)",
            color: "#FF4A01",
          }}
          disabled={verifying}
        >
          Continue
        </Button>
      </div>
    </>
  );
}
